import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { accountGuard } from './core/account/account.guard';
import { platformAdminGuard } from './core/auth/platform-admin.guard';

export const routes: Routes = [
  {
    // Landing pública. Es la raíz del sitio y se prerenderiza (app.routes.server.ts).
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./features/landing/landing.component').then((m) => m.LandingComponent),
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'auth/callback',
    loadComponent: () =>
      import('./features/auth/callback/auth-callback.component').then(
        (m) => m.AuthCallbackComponent,
      ),
  },
  {
    // La cuenta vive en la URL: un enlace compartido abre la cuenta correcta
    // sin importar cuál tuviera activa el receptor.
    path: 'o/:slug/app',
    canActivate: [authGuard, accountGuard],
    loadComponent: () => import('./shell/app-shell.component').then((m) => m.AppShellComponent),
    children: [
      {
        path: 'procesos',
        loadComponent: () =>
          import('./features/procesos/procesos.component').then((m) => m.ProcesosComponent),
      },
      {
        path: 'procesos/:id',
        loadComponent: () =>
          import('./features/procesos/detalle/detalle.component').then(
            (m) => m.ProcesoDetalleComponent,
          ),
      },
      {
        path: 'busquedas',
        loadComponent: () =>
          import('./features/busquedas/busquedas.component').then((m) => m.BusquedasComponent),
      },
      {
        path: 'seguimientos',
        loadComponent: () =>
          import('./features/seguimientos/seguimientos.component').then(
            (m) => m.SeguimientosComponent,
          ),
      },
      {
        path: 'carpetas',
        loadComponent: () =>
          import('./features/carpetas/carpetas.component').then((m) => m.CarpetasComponent),
      },
      {
        path: 'equipo',
        loadComponent: () =>
          import('./features/equipo/equipo.component').then((m) => m.EquipoComponent),
      },
      { path: '', pathMatch: 'full', redirectTo: 'procesos' },
    ],
  },
  {
    // Compatibilidad con enlaces y sesiones anteriores a la cuenta en la URL.
    path: 'app',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/account-redirect.component').then((m) => m.AccountRedirectComponent),
    children: [
      {
        path: '**',
        loadComponent: () =>
          import('./features/account-redirect.component').then((m) => m.AccountRedirectComponent),
      },
    ],
  },
  {
    path: 'plataforma',
    canActivate: [platformAdminGuard],
    loadComponent: () =>
      import('./features/platform/platform-shell.component').then((m) => m.PlatformShellComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'organizaciones' },
      {
        path: 'organizaciones',
        loadComponent: () =>
          import('./features/platform/organizaciones/organizaciones.component').then(
            (m) => m.OrganizacionesComponent,
          ),
      },
      {
        path: 'organizaciones/:accountId',
        loadComponent: () =>
          import('./features/platform/organizacion-detalle/organizacion-detalle.component').then(
            (m) => m.OrganizacionDetalleComponent,
          ),
      },
      {
        path: 'registro',
        loadComponent: () =>
          import('./features/platform/registro/registro.component').then((m) => m.RegistroComponent),
      },
      {
        path: 'compras',
        loadComponent: () =>
          import('./features/platform/compras/compras.component').then((m) => m.ComprasComponent),
      },
      {
        path: 'auditoria',
        loadComponent: () =>
          import('./features/platform/auditoria/auditoria.component').then((m) => m.AuditoriaComponent),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
